<template>
    <div>
        <!-- Button trigger modal -->
        <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalcreareditar">
        Launch demo modal
        </button> -->

        <!-- Modal -->
        <div class="modal fade" id="modalcreareditar" data-backdrop="static" data-keyboard="false" tabindex="-1"
            role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div :class="`modal-dialog modal-dialog-centered modal-${configuracion ? configuracion.ancho : 'lg'}`"
                role="document" style="width:80%">
                <div class="modal-content">
                    <div class="modal-header" style="background-color:#172b4d;">
                        <h5 class="modal-title" id="exampleModalLabel" style="color:#fff">
                            {{ configuracion ? configuracion.titulo.toUpperCase() : '' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" style="color:#fff;font-size:1.2em">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="alert">
                                    <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
                                    <!-- <span class="alert-text"><strong>Error de Validación!</strong></span> -->
                                    <ul>
                                        <li v-for="(m, index) in mensaje" :key="index">{{ `${m}` }}</li>
                                    </ul>
                                    <!-- <span class="alert-text" v-for="(m,index) in mensaje" :key="index"> <strong>{{`${m},`}}</strong></span> -->

                                    <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div :class="`col col-md-${i.cols}`" v-for="(i, index) in inputs" :key="index">

                                <!-- texto -->
                                <div class="form-group" v-if="i.tipo == 'texto'">
                                    <label class="form-control-label" for="">{{ i.label }}</label>
                                    <div class="input-group input-group-merge">
                                        <!-- <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-none"></i></span>
                            </div> -->
                                        <input class="form-control" type="text" v-model="i.valor"
                                            :disabled="i.disabled">
                                    </div>
                                </div>
                                <!-- texto -->

                                <!-- numero -->
                                <div class="form-group" v-if="i.tipo == 'numero'">
                                    <label class="form-control-label" for="">{{ i.label }}</label>
                                    <div class="input-group input-group-merge">
                                        <!-- <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-none"></i></span>
                            </div> -->
                                        <input class="form-control" type="number" v-model="i.valor"
                                            :disabled="i.disabled">
                                    </div>
                                </div>
                                <!-- numero -->

                                <!-- select -->
                                <div class="form-group" v-if="i.tipo == 'select'">
                                    <label class="form-control-label" for="">{{ i.label }}</label>
                                    <div class="input-group input-group-merge">
                                        <select class="form-control" v-model="i.valor" :disabled="i.disabled">
                                            <option value="">--No Seleccionar --</option>
                                            <option v-for="(opc, index) in i.opciones" :key="index"
                                                :value="devuelve_valor(opc, i.valor_opcion)">
                                                {{ devuelve_valor(opc, i.label_opcion) }}</option>
                                        </select>
                                        <!-- <select class="form-control" v-model="i.valor">
                                <option>-- Ninguna --</option>
                                <option v-for="(opc,index) in i.opciones" :key="index" :value="opc.valor">{{opc.label}}</option>
                            </select> -->
                                    </div>
                                </div>
                                <!-- select -->

                                <!-- multiselect -->
                                <!-- <div class="form-group" v-if="i.tipo == 'multiselect'">
                            <label class="form-control-label" for="">{{i.label}}</label>
                            <div class="input-group input-group-merge">
                                <multiselect :searchable="true" :multiple="i.multiple" v-model="i.valor" :options="i.opciones" :label="i.label_opcion" :value="i.valor_opcion"></multiselect>
                            </div>
                        </div> -->
                                <!-- multiselect -->

                                <div class="form-group" v-if="i.tipo == 'multiselect'">
                                    <label class="form-control-label" for="">{{ i.label }}</label>
                                    <div class="input-group input-group-merge">
                                        <select class="form-control" v-model="i.valor" multiple>
                                            <option v-for="(opc, index) in i.opciones" :key="index"
                                                :value="devuelve_valor(opc, i.valor_opcion)">
                                                {{ devuelve_valor(opc, i.label_opcion) }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group" v-if="i.tipo == 'v-select_multiple'">
                                    <label for="form-control-label">{{ i.label }}</label>
                                    <v-select class="" :reduce="option => option.id" v-model="i.valor"
                                        :options="i.opciones" :label="i.label_opcion" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                No se Encontraron Resultados Para <em>{{ search }}</em>.
                                            </template>
                                            <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </div>

                                <div class="form-group" v-if="i.tipo == 'v-select'">
                                    <label for="form-control-label">{{ i.label }}</label>
                                    <v-select class="" :reduce="option => option.id" v-model="i.valor"
                                        :options="i.opciones" :label="i.label_opcion">
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                No se Encontraron Resultados Para <em>{{ search }}</em>.
                                            </template>
                                            <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </div>


                                <!-- Select Loadable -->
                                <div class="form-group" v-if="i.tipo == 'select-loadable'">
                                    <label for="form-control-label">{{ i.label }}</label>
                                    <v-select :disabled="i.disabled" style="background-color:#fff" class=""
                                        @search="filtrarOpciones($event, i, index)" :reduce="option => option.id"
                                        v-model="i.valor" :options="i.opciones" :label="i.label_opcion">
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                No se Encontraron Resultados Para <em>{{ search }}</em>.
                                            </template>
                                            <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </div>
                                <!-- Select Loadable -->




                                <!-- datetime -->
                                <div class="form-group" v-if="i.tipo == 'datetime'">
                                    <label class="form-control-label" for="">{{ i.label }}</label>
                                    <div class="input-group input-group-merge">
                                        <input v-model="i.valor" class="form-control" type="date" value="" id="">
                                    </div>
                                </div>
                                <!-- datetime -->

                                <!--  datetimepicker -->
                                <div class="form-group" v-if="i.tipo == 'datetimepicker'">
                                    <label class="form-control-label" for="">{{ i.label }}</label>
                                    <div class="input-group input-group-merge">
                                        <datetime value-zone="America/Santiago" zone="America/Santiago"
                                            format="dd-MM-yyyy HH:mm" input-class="" v-model="i.valor" type="datetime">
                                        </datetime>
                                    </div>

                                </div>

                                <!--  datetimepicker -->


                                <!-- checkbox -->
                                <div class="custom-control custom-checkbox" v-if="i.tipo == 'checkbox'">
                                    <input type="checkbox" class="" :id="i.key" v-model="i.valor"
                                        style="margin-right: 10px;">
                                    <label class="" :for="i.key"> {{ i.label }}</label>
                                </div>
                                <!-- checkbox -->

                                <!-- file -->
                                <div class="form-group" v-if="i.tipo == 'file'">
                                    <label>{{ i.label }}</label>

                                    <input type="file" class="form-control" @change="i.valor = $event.target.files[0]">

                                    <small v-if="i.valor">
                                        {{ i.valor.name }}
                                    </small>
                                </div>
                                <!-- file -->

                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <small>(*) Campos Obligatorios</small>
                            </div>
                        </div>
                        <!-- <pre>{{inputs}}</pre> -->
                        <!-- <pre>Configuracion: {{configuracion}}</pre> -->
                    </div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                        <div class="spinner-3" v-show="spinner"></div>
                        <button type="button" @click="procesar"
                            :class="`btn ${configuracion.clase_boton ? configuracion.clase_boton : 'btn-primary'}`">{{
                                configuracion.titulo_boton }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props: ['configuracion'],
    data: () => ({
        titulo: '',
        ruta: '',
        tipo_peticion: '',
        errores: {},
        alert: false,
        valor: null,
        spinner: false,
        //inputs:[]
    }),
    mounted: function () {
        this.$parent.$on('abrir', function (config) {
            //document.getElementById('modalcreareditar').modal('show');
            //this.$set(this.inputs,config.inputs);
            //this.inputs = config.inputs;
            ////console.log('inputs',this.inputs);
            $('#modalcreareditar').modal({ show: true })
        });
    },
    methods: {
        /*async procesar() {
            this.spinner = true;
            let body = {};
            let url = `${this.api}${this.configuracion.ruta}`;
            this.inputs.forEach(i => {
                if (i.tipo == 'hidden' || i.tipo == 'texto' || i.tipo == 'select' || i.tipo == 'numero' || i.tipo == 'datetime' || i.tipo == 'multiselect' || i.tipo == 'checkbox' || i.tipo == 'v-select_multiple' || i.tipo == 'select-loadable' || i.tipo == 'v-select') {
                    body[i.key] = i.valor;
                }
                if (i.tipo == 'datetimepicker') {
                    body[i.key] = this.$moment(i.valor).format('YYYY-MM-DD HH:mm')
                }
            });
            if (this.configuracion.tipo_ruta == 'post') {
                await this.axios.post(url, body, this.cabeceras_json).then((res) => {
                    //console.log('realizado',res.data);
                    if (res.data.codigo == 200) {
                        this.alert = false;
                        this.errores = {};
                        this.$emit('realizado');
                    } else {
                        //error de validacion
                        this.errores = res.data.data;
                        this.alert = true;
                        console.log('error validacion', res.data);
                    }
                }).catch((e) => {
                    //console.log('error',e);
                });
            } else if (this.configuracion.tipo_ruta == 'put') {
                await this.axios.put(url, body, this.cabeceras_json).then((res) => {
                    //console.log('realizado',res.data);
                    if (res.data.codigo == 200) {
                        this.alert = false;
                        this.errores = {};
                        this.$emit('realizado');
                        $('#modalcreareditar').modal('toggle');
                    } else {
                        //error de validacion
                        this.errores = res.data.data;
                        this.alert = true;
                    }
                    //this.$emit('realizado');
                }).catch((e) => {
                    //console.log('error',e);
                });
            }
            //console.log('body',body);
            this.spinner = false;
        },*/
        async procesar() {
            this.spinner = true;

            const url = `${this.api}${this.configuracion.ruta}`;
            const tieneArchivo = this.inputs.some(i => i.tipo === 'file');

            let body = tieneArchivo ? new FormData() : {};

            this.inputs.forEach(i => {

                let valor = i.valor;

                if (i.tipo == 'datetimepicker') {
                    valor = i.valor
                        ? this.$moment(i.valor).format('YYYY-MM-DD HH:mm')
                        : '';
                }

                if (tieneArchivo) {

                    if (i.tipo == 'file') {
                        if (i.valor) {
                            body.append(i.key, i.valor);
                        }
                    } else {
                        body.append(i.key, valor ?? '');
                    }

                } else {

                    if (
                        i.tipo == 'hidden' ||
                        i.tipo == 'texto' ||
                        i.tipo == 'select' ||
                        i.tipo == 'numero' ||
                        i.tipo == 'datetime' ||
                        i.tipo == 'multiselect' ||
                        i.tipo == 'checkbox' ||
                        i.tipo == 'v-select_multiple' ||
                        i.tipo == 'select-loadable' ||
                        i.tipo == 'v-select' ||
                        i.tipo == 'datetimepicker'
                    ) {
                        body[i.key] = valor;
                    }

                }

            });

            // Laravel method spoofing para PUT con archivos
            if (tieneArchivo && this.configuracion.tipo_ruta == 'put') {
                body.append('_method', 'PUT');
            }

            const cabeceras = tieneArchivo
                ? this.cabeceras_archivo
                : this.cabeceras_json;

            try {

                let res;

                if (this.configuracion.tipo_ruta == 'post') {

                    res = await this.axios.post(url, body, cabeceras);

                } else if (this.configuracion.tipo_ruta == 'put') {

                    if (tieneArchivo) {
                        // Enviar como POST con _method=PUT
                        res = await this.axios.post(url, body, cabeceras);
                    } else {
                        // PUT normal cuando no hay archivos
                        res = await this.axios.put(url, body, cabeceras);
                    }

                }

                if (res.data.codigo == 200) {
                    this.alert = false;
                    this.errores = {};
                    this.$emit('realizado');

                    if (this.configuracion.tipo_ruta == 'put') {
                        $('#modalcreareditar').modal('toggle');
                    }

                } else {
                    this.errores = res.data.data;
                    this.alert = true;
                }

            } catch (e) {
                console.error(e);
            }

            this.spinner = false;
        },
        devuelve_valor(item, path) {
            let keys = path.split('.');
            let valor = item;
            keys.forEach(k => {
                for (var key in valor) {
                    if (key == k) {
                        valor = valor[key];
                    }
                }

            });
            return valor;
        },
        async filtrarOpciones(search, input, index) {
            let append = '';
            if (input.append_parametro) {
                append = input.append_parametro;
            }
            await this.axios.get(`${this.api}${input.ruta}?${input.parametro}=${search}${append}&limit=9999999999`, this.cabeceras_json).then((res) => {
                this.inputs[index].opciones = res.data.data.data
                ////console.log('res',res.data.data.data);
            }).catch((e) => {
                //console.log(e);
            });
            ////console.log('search',search)
            ////console.log('col',col)
        },
    },
    computed: {
        ...mapState(['inputs', 'cabeceras_json', 'cabeceras_archivo', 'api']),
        mensaje() {
            let devolver = [];
            if (this.errores instanceof Object) {
                Object.keys(this.errores).forEach(key => {
                    let array = this.errores[key];
                    array.forEach(mensaje => {
                        devolver.push(mensaje);
                    });
                });
            } else {
                this.errores.forEach(m => {
                    devolver.push(m);
                });
            }

            return devolver;
        }
    },
    watch: {
        configuracion: (viejo, nuevo) => {
            return nuevo;
        }
    }
}
</script>